"use client";

import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useEffect, useState } from "react";
import Spinner from "./ui/Spinner";
import CustomSelect from "@/components/ui/input/CustomSelect";
import { cdnCommonPath } from "@/constants/cdnUrls";
import { LANGUAGE_NAMES } from "@/constants/languages";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { commonService } from "@/services/commonService";
export default function LanguageSwitcher({ handleLanguageChange, value }) {
  const [languagesList, setLanguagesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const t = useTranslationDetector();
  const getLanguages = async () => {
    try {
      setLoading(true);
      const response = await commonService.getLanguages();
      if (response?.Cultures) {
        setLanguagesList(response.Cultures);
      }
    } catch (error) {
      console.error("LanguageSwitcher: Error getting languages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLanguages();
  }, []);

  const onChange = (e) => {
    const newLanguage = e.target.value;
    handleLanguageChange(newLanguage);
  };

  // Convert locales to options array for Select component
  const languageOptions =
    languagesList?.length > 0
      ? languagesList.map((language) => ({
          value: language.LanguageCode,
          label: language.LanguageName,
        }))
      : Object.entries(LANGUAGE_NAMES).map(([code, info]) => ({
          value: code,
          label: info.name,
        }));

  return loading ? (
    <div className="border-border flex items-center justify-between rounded-lg border p-4">
      <span className="flex items-center gap-2">
        <span>
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["globe"]}
            className="text-[20px]"
          />
        </span>
        <span>{t("common.loading")}</span>
      </span>
      <Spinner className="h-4 w-4 animate-spin" />
    </div>
  ) : (
    <CustomSelect
      label={t("common.languageLabel")}
      value={value}
      onChange={onChange}
      options={languageOptions}
      optionListClassName="md:max-h-[200px]!"
      renderOption={(option) => (
        <div className="flex items-center gap-2">
          <Image
            src={`${cdnCommonPath}${option.value.toLowerCase()}.svg`}
            alt={option.label}
            width={20}
            height={20}
          />
          <span className="font-medium">{option.label}</span>
        </div>
      )}
    />
  );
}
